/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StaffDocumentFile
 */
export interface StaffDocumentFile {
    /**
     * 
     */
    position: number;
    /**
     * 
     */
    original_name: string;
    /**
     * 
     */
    content_type: string;
    /**
     * 
     */
    size: number;
    /**
     * 
     */
    has_pdf: boolean;
}

/**
 * Check if a given object implements the StaffDocumentFile interface.
 */
export function instanceOfStaffDocumentFile(value: object): value is StaffDocumentFile {
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('original_name' in value) || value['original_name'] === undefined) return false;
    if (!('content_type' in value) || value['content_type'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('has_pdf' in value) || value['has_pdf'] === undefined) return false;
    return true;
}

export function StaffDocumentFileFromJSON(json: any): StaffDocumentFile {
    return StaffDocumentFileFromJSONTyped(json, false);
}

export function StaffDocumentFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffDocumentFile {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'],
        'original_name': json['original_name'],
        'content_type': json['content_type'],
        'size': json['size'],
        'has_pdf': json['has_pdf'],
    };
}

export function StaffDocumentFileToJSON(json: any): StaffDocumentFile {
    return StaffDocumentFileToJSONTyped(json, false);
}

export function StaffDocumentFileToJSONTyped(value?: StaffDocumentFile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'original_name': value['original_name'],
        'content_type': value['content_type'],
        'size': value['size'],
        'has_pdf': value['has_pdf'],
    };
}

